<template lang="html">
  <div class="rules">
    <common-header></common-header>
   <div class="imgContainer">
    	<div><img src="../../../assets/img/aboutUsKv.png" /></div>
    </div>
    <div class="rulesContainer">
    	<div class="usTab">免责条款
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">免责条款</div>
    		<div class="eng-title">一、积分免责条款</div>
    		<div class="abstract">
				国泰君安证券君弘积分兑换所提供的各项回馈项目除国泰君安证券自己的产品和服务外，涉及到的第三方产品和服务均由该产品/服务供应商直接提供予君弘会员，国泰君安证券与供应商间并无合伙、经销、代理关系、广告媒体或保证人关系；如会员与供应商所提供的回馈产品或服务及售后服务有争议时，概由各供应商负责。国泰君安证券不承担任何责任。</div>
			<div class="eng-title">二、国泰君安解释权</div>
    		<div class="abstract">
				国泰君安证券君弘俱乐部保留对本积分计划办法中条款解释的权利，并有权根据需要取消本计划或增删、修订本规定的权利（包括但不限于参加资格、积分计算、兑换产品及兑换标准），并于国泰君安证券相关媒体（如公司网站、电子对账单等）、报纸或者各分支营业网点公告后生效。</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	created(){
	  		//
	  	},
	}
</script>

<style lang="less" scoped>
	.rules{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				border-radius:10px;
				overflow:hidden;
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.rulesContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:20px;
					font-size:28px;
					letter-spacing:0;
					line-height:28px;
				}
				.abstract{
					margin-top:20px;
					font-size:28px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:50px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/rules.vue